"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var icons_1 = require("@material-ui/icons");
var core_1 = require("@material-ui/core");
var pomodoroContext_1 = __importDefault(require("./pomodoroContext"));
var PomodoroTimer_1 = __importDefault(require("./PomodoroTimer"));
var PomodoroPopoverContainer_1 = __importDefault(require("./PomodoroPopoverContainer"));
var PomodoroSetting_1 = __importDefault(require("./PomodoroSetting"));
var PomodoroSlider_1 = __importDefault(require("./PomodoroSlider"));
var IconButton_1 = __importDefault(require("../IconButton"));
var Button_1 = __importDefault(require("../Button"));
var ActionButtons_1 = __importDefault(require("../ActionButtons"));
var PomodoroCycle_1 = __importDefault(require("./PomodoroCycle"));
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        resetButton: {
            position: 'absolute',
            left: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[400],
        },
        settingsButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[400],
        },
        returnButton: {
            position: 'absolute',
            left: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[400],
        },
        timerView: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
        },
        message: {
            textAlign: 'center',
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(1),
        },
        cycles: {
            width: '100%',
            marginTop: 8,
        },
        timeSettings: {
            paddingLeft: '15%',
            paddingRight: '15%',
        },
        listItem: {
            paddingLeft: 0,
        },
        listItemSecondaryAction: {
            marginRight: -16,
        },
    });
});
var PomodoroContainer = function () {
    var _a = react_1.useContext(pomodoroContext_1.default), clear = _a.clear, cycles = _a.cycles, cycle = _a.cycle, remainingTime = _a.remainingTime, focusTime = _a.focusTime, breakTime = _a.breakTime, message = _a.message, mode = _a.mode, progress = _a.progress, paused = _a.paused, studyMode = _a.studyMode, play = _a.play, pause = _a.pause, enablePreset = _a.enablePreset, presets = _a.presets, setFocusTime = _a.setFocusTime, setBreakTime = _a.setBreakTime, setCycles = _a.setCycles, setStudyModeEnabled = _a.setStudyModeEnabled, reset = _a.reset, other = __rest(_a, ["clear", "cycles", "cycle", "remainingTime", "focusTime", "breakTime", "message", "mode", "progress", "paused", "studyMode", "play", "pause", "enablePreset", "presets", "setFocusTime", "setBreakTime", "setCycles", "setStudyModeEnabled", "reset"]);
    var classes = useStyles();
    var _b = __read(react_1.useState('timer'), 2), view = _b[0], setView = _b[1];
    function showSettings() {
        setView('settings');
    }
    function showTimer() {
        setView('timer');
    }
    function onChangeFocusTime(event, value) {
        if (typeof value === 'number') {
            setFocusTime(value);
        }
    }
    function onChangeBreakTime(event, value) {
        if (typeof value === 'number') {
            setBreakTime(value);
        }
    }
    function onChangeCycles(event, value) {
        if (typeof value === 'number') {
            setCycles(value);
        }
    }
    function onChangeStudyModeEnabled(evemt, enabled) {
        setStudyModeEnabled(enabled);
    }
    function renderCycles() {
        var cycleItems = [];
        for (var i = 1; i <= cycles; i += 1) {
            var status_1 = i > cycle ? 'planned' : 'completed';
            var cycleProgress = i > cycle ? 0 : 100;
            if (i === cycle) {
                status_1 = 'active';
                cycleProgress = 100 - progress;
            }
            cycleItems.push(react_1.default.createElement(PomodoroCycle_1.default, { key: i, focusTime: focusTime, breakTime: breakTime, status: status_1, mode: mode, modeProgress: cycleProgress }));
        }
        return cycleItems;
    }
    return (react_1.default.createElement(PomodoroPopoverContainer_1.default, __assign({}, other),
        view === 'timer' && (react_1.default.createElement("div", { className: classes.timerView },
            react_1.default.createElement(Button_1.default, { size: "small", variant: "text", onClick: clear, className: classes.resetButton, color: "inherit" }, "Reset"),
            react_1.default.createElement(IconButton_1.default, { size: "small", color: "inherit", onClick: showSettings, className: classes.settingsButton },
                react_1.default.createElement(icons_1.SettingsRounded, null)),
            message !== 'none' && (react_1.default.createElement(core_1.Typography, { variant: "h5", className: classes.message },
                message === 'break' && 'Time for a break!',
                message === 'focus' && 'Back to work!',
                message === 'complete' && 'Session complete!')),
            react_1.default.createElement(PomodoroTimer_1.default, { mode: mode, time: remainingTime, progress: progress, paused: paused, onClickPause: pause, onClickPlay: play, onClickReset: reset }),
            react_1.default.createElement("div", { className: classes.cycles }, renderCycles()))),
        view === 'settings' && (react_1.default.createElement("div", null,
            react_1.default.createElement(IconButton_1.default, { size: "small", color: "inherit", onClick: showTimer, className: classes.returnButton },
                react_1.default.createElement(icons_1.ArrowBackRounded, null)),
            react_1.default.createElement("div", { className: classes.timeSettings },
                react_1.default.createElement(ActionButtons_1.default, { marginBottom: true, align: "space-between" },
                    react_1.default.createElement(Button_1.default, { variant: "text", onClick: function () { return enablePreset(presets.short); } }, "Short"),
                    react_1.default.createElement(Button_1.default, { variant: "text", onClick: function () { return enablePreset(presets.standard); } }, "Standard"),
                    react_1.default.createElement(Button_1.default, { variant: "text", onClick: function () { return enablePreset(presets.long); } }, "Long")),
                react_1.default.createElement(PomodoroSetting_1.default, { label: "Focus", value: react_1.default.createElement(react_1.Fragment, null,
                        focusTime / 60,
                        " minutes") },
                    react_1.default.createElement(PomodoroSlider_1.default, { step: 5 * 60, min: 5 * 60, max: 60 * 60, value: focusTime, 
                        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                        // @ts-ignore
                        onChange: onChangeFocusTime })),
                react_1.default.createElement(PomodoroSetting_1.default, { label: "Break", value: react_1.default.createElement(react_1.Fragment, null,
                        breakTime / 60,
                        " minutes") },
                    react_1.default.createElement(PomodoroSlider_1.default, { step: 1 * 60, min: 1 * 60, max: 30 * 60, value: breakTime, 
                        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                        // @ts-ignore
                        onChange: onChangeBreakTime })),
                react_1.default.createElement(PomodoroSetting_1.default, { label: "Cycles", value: react_1.default.createElement(react_1.Fragment, null,
                        cycles,
                        " cycles") },
                    react_1.default.createElement(PomodoroSlider_1.default, { step: 1, min: 1, max: 10, value: cycles, 
                        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                        // @ts-ignore
                        onChange: onChangeCycles }))),
            react_1.default.createElement(core_1.List, null,
                react_1.default.createElement(core_1.ListItem, null,
                    react_1.default.createElement(core_1.ListItemText, { primary: "Study mode" }),
                    react_1.default.createElement(core_1.ListItemSecondaryAction, null,
                        react_1.default.createElement(core_1.Switch, { edge: "end", onChange: onChangeStudyModeEnabled, checked: studyMode }))),
                react_1.default.createElement(core_1.ListItem, null,
                    react_1.default.createElement(core_1.ListItemText, { secondary: "To help prevent procrastination, in study mode, a chime will be played when 21st Night is not in focus during focus time." })))))));
};
exports.default = PomodoroContainer;
//# sourceMappingURL=PomodoroContainer.js.map